// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__0J9uM","logo":"styles_logo__6c5Fg","containerIcon":"styles_containerIcon__zqjbg","logoName":"styles_logoName__IAn4f"};